<template>
    <div class="rivacypolicy">
        <el-row type="flex"
                class="row-bg"
                justify="center">
            <el-col :span="20">
                <div class="agreement">
                    <h1 class="page-title">《壹米滴答合作方清单》</h1>
                    <div style="text-indent: 1em">更新日期:2025年10月20日</div>
                    <div style="text-indent: 1em">基于保障产品稳定运行、实现产品功能等目的，我们会接入由第三方提供的SDK，我们将对第三方获取数据的行为进行监测，以保护您的个人信息权利和数据安全。为满足用户需求，产品功能可能发生新增或变更，若因此导致调整接入的第三方SDK，我们会及时更新本列表，向您展示第三方SDK的最新情况。目前，我们引入第三方SDK的情况列明如下:</div>
                    <div style="text-indent: 0em;font-weight: bold;font-size: 18px;line-height: 50px">SDK列表</div>
                    <div><span style="font-weight: bold;line-height: 40px;">产品:百度地图</span></div>
                    <div>第三方公司名称:百度在线网络技术(北京)有限公司</div>
                    <div>使用目的:服务点查询、通过定位识别附近地址快速填写下单地址</div>
                    <div>使用场景:快件查询、附近服务点查询、便捷下单</div>
                    <div>共享信息名称:位置信息(精确定位信息)</div>
                    <div>提供方式:服务点查询时由SDK本地收集，不涉及共享数据；便捷下单时SDK会将地理位置信息传至百度服务器，百度返回该经纬度附近的地址</div>
                    <div>隐私保护说明:<a href="http://lbsyun.baidu.com/index.php?title=open/privacy" target="_blank" class="text_link">http://lbsyun.baidu.com/index.php?title=open/privacy</a></div>
                    <div><span style="font-weight: bold;line-height: 40px;">产品:微信</span></div>
                    <div>第三方公司名称:深圳市腾讯计算机系统有限公司</div>
                    <div>使用目的:使用第三方账号登录</div>
                    <div>使用场景:联合登录</div>
                    <div>共享信息名称:用户标识信息(微信openid)</div>
                    <div>提供方式:联合登录场景下不涉及共享数据，由微信回传用户账号ID</div>
                    <div>隐私保护说明:<a href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy" target="_blank" class="text_link">https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</a></div>
                    <div style="height: 20px;"></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    watch: {},
    created() {},
    methods: {}
};
</script>

<style scoped lang="scss">
.rivacypolicy {
    padding-bottom: 50px;
    background-color: #fff;
    .agreement {
        padding: 20px;
        height: 100%;
        font-size: 14px;
        line-height: 1.8;
        .page-title {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin: 0 0 30px 0;
            padding: 20px 0;
            border-bottom: 2px solid #e0e0e0;
            width: 100%;
        }
        div {
            text-indent: 1em;
            margin-bottom: 10px;
            color: #333;
        }
        .text_link {
            color: #FFAF00;
            font-weight: bold;
            cursor: pointer;
            text-decoration: underline;
            &:hover {
                color: #ff9500;
            }
        }
        a {
            color: #FFAF00;
            font-weight: bold;
            text-decoration: underline;
            &:hover {
                color: #ff9500;
            }
        }
    }
}
</style>

